/** Microsoft Clarity project id from Vite env, when set. */
export const CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID as string | undefined

/** True when `VITE_CLARITY_PROJECT_ID` is present for this build. */
export const isClarityProjectConfigured = Boolean(CLARITY_PROJECT_ID)
